import { CalendarDialog } from "./CalendarDialog";
import { connect } from "../connect-with-dialog";
import { html, render } from "lit-html";
import { formatRangeToLocale } from "@escapio/shared/l10n/date";
import { translate } from "@escapio/shared/l10n/translate";
import { stateful } from "@escapio/shared/components/element-builder";

customElements.define(
	"esc-calendar-input",
	stateful(
		class extends connect(CalendarDialog, HTMLElement) {
			static getInitialState() {
				return {
					arrival: null,
					departure: null,
					renderDayAddonsFn: null,
					extraValidationFn: null,
				};
			}

			connectedCallback() {
				this.addEventListener("DialogClosed", () => this.updateStateful());
			}

			onDialogChanged({ detail }) {
				this.renderDateRange(detail.arrival, detail.departure);
			}

			onDialogConfirm({ detail }) {
				this.dispatchEvent(new CustomEvent("confirm", { detail }));
			}

			render() {
				this.renderDateRange(this.arrival, this.departure);
			}

			renderDateRange(arrival, departure) {
				const dateRangeLabel =
					arrival && departure
						? formatRangeToLocale(arrival, departure)
						: html`<span class="calendar-view--placeholder">
								${translate("calendar_view_no_dates_set")}
							</span>`;
				render(
					html`<div class="input-with-icon--addon">
							<span class="fa fa-calendar"></span>
						</div>
						<div class="input">${dateRangeLabel}</div>`,
					this,
					{
						host: this,
					},
				);
			}

			getDialogParams() {
				return [
					this.arrival,
					this.departure,
					this.getAttribute("min-duration"),
					this.getAttribute("max-duration"),
					this.renderDayAddonsFn,
					this.extraValidationFn,
					this.getAttribute("num-months"),
				];
			}
		},
	),
);
